import type { FC } from "react";
import { useMatchMinute } from "../../../../hooks/use-match-minute";
import type { Post } from "../../../../types/post.types";
import PostFooter from "../../components/post-footer/post-footer";
import PostHeader from "../../components/post-header/post-header";
import PostText from "../../components/post-text/post-text";
import * as CSS from "../../posts.styles";

type StandardPostProps = {
	post: Post;
};

const StandardPost: FC<StandardPostProps> = ({ post }) => {
	const minute = useMatchMinute(post.date, post.minute);

	return (
		<CSS.Post>
			<PostHeader time={minute} type={post.type} />
			<div style={{ marginLeft: 44 }}>
				<PostText postId={post.id} text={post.text} />
				<PostFooter postId={post.id} postType={post.type} />
			</div>
		</CSS.Post>
	);
};

export default StandardPost;
